module.exports = __webpack_public_path__ + "img/landing-ebay.61619d77.svg";